<template>
  <div>
    <div class="order-main">
      <van-row>
        <van-col :span="12">
          <div style="font-size: small;margin: 10px">{{ orderInfos }}</div>
        </van-col>
        <van-col :span="12">
          <div style="text-align:right;font-size: small;margin: 10px" @click="bindAccount">绑定账号</div>
        </van-col>
      </van-row>
      <van-divider dashed style="color: #4d84e2;margin: 3px;"></van-divider>
      <van-tabs type="card" style="width: 100%" v-model="orderRequirement.oneLeave">
        <van-tab title="垫付单">
          <van-tabs type="card" v-model="orderRequirement.twoLeave">
            <van-tab title="全部"></van-tab>
            <van-tab title="立返"></van-tab>
            <van-tab title="货返"></van-tab>
          </van-tabs>
        </van-tab>
        <van-tab title="浏览单"></van-tab>
        <van-tab title="试用任务"></van-tab>
      </van-tabs>
      <div>
        <van-radio-group v-model="bindShop">
        <van-card
            v-for="(item, index) in cardData" :key="index">
          <template #thumb>
            <div style="margin: 15%">
              <van-image width="3rem" height="3rem" :src="getIcon(parseInt(item.plateformSerNum))" ></van-image>
            </div>
          </template>
          <template #tags>
            <van-row :gutter="20">
              <van-col :span="19">
              <div class="leftArea" style="font-size:large; line-height: 33px">
                <div>{{ item.plateformUsername }}<span style="margin-left: 5px;font-size: small">({{
                    item.statusStr
                  }})</span></div>
                <div style="margin-top: 2px;"><span style="color: #4d84e2;font-size: xx-small">今日已接单({{ item.customerOrderLimit && item.customerOrderLimit.orderUsed ? item.customerOrderLimit.orderUsed:0}}/{{getDayOrders(item)}}), {{getMonthDays(item)}}天内接单({{item.customerOrderLimit && item.customerOrderLimit.orderMonthUsed?item.customerOrderLimit.orderMonthUsed:0}}/{{getMonthOrders(item)}})</span></div>
              </div>
              </van-col>
              <van-col span="5">
              <van-radio :name="index" @click="selectShop(item)" style="margin-top: 45%;"></van-radio>
              </van-col>
            </van-row>
          </template>
        </van-card>
        </van-radio-group>
      </div>
    </div>
   <div style="border-radius: 50%;background-color:white;width: 60px;height: 60px;position: fixed; left: 42%; bottom: 10px;justify-self: center;z-index: 99999999;" v-show="disabled">
    <van-button round type="primary"
                style="width: 60px;height: 60px;position: fixed; left: 42%; bottom: 10px;justify-self: center;"
                :text="btn"
                :disabled="disabled"
                @click="orderClick">
    </van-button>
    </div>
    <van-dialog v-model="isShow"
      :show-confirm-button="false"
      :show-cancel-button="false">
      <div style="margin: 20px;font-size: smaller">
      <van-row :gutter="2">
        <van-col :span="12">
          <div>店铺名称：</div>
        </van-col>
        <van-col :span="12">
          <div style="text-align: right">
            {{getShopNameLimit(orderInfo.shopName)}}
          </div>
        </van-col>
      </van-row>
      <van-divider></van-divider>
      <van-row :gutter="2">
        <van-col :span="12">
          <div>任务类型：</div>
        </van-col>
        <van-col :span="12">
          <div style="text-align: right">
            {{orderInfo.taskType}}
          </div>
        </van-col>
      </van-row>
      <van-divider></van-divider>
      <van-row :gutter="2">
        <van-col :span="12">
          <div>垫付本金：</div>
        </van-col>
        <van-col :span="12">
          <div style="text-align: right">
            {{orderInfo.money}}
          </div>
        </van-col>
      </van-row>
      <van-divider></van-divider>
      <van-row :gutter="2">
        <van-col :span="12">
          <div>服务佣金：</div>
        </van-col>
        <van-col :span="12">
          <div style="text-align: right">
            {{orderInfo.commission}}
          </div>
        </van-col>
      </van-row>
        <van-divider></van-divider>
        <van-row :gutter="2">
          <van-col :span="24">
            <div style="color: crimson;word-break:break-all; word-wrap: break-word; overflow:auto;margin: 5px">
              {{getServiceAttach(orderInfo.taskRequirement)}}
            </div>
          </van-col>
        </van-row>
        <van-divider></van-divider>
        <van-row :gutter="1">
          <van-row :gutter="2">
            <van-col :span="24">
              <div>
                商家要求：
              </div>
            </van-col>
          </van-row>
          <van-row :gutter="2">
            <van-col :span="24">
              <div style="word-break:break-all; word-wrap: break-word; overflow:auto;margin: 2%;">
                {{orderInfo.businessRequirement}}
              </div>
            </van-col>
          </van-row>
          <van-row :gutter="2">
            <van-col :span="24">
              <div style="text-align: right;color: gray">
                {{timeCount}}秒之后自动关闭
              </div>
            </van-col>
          </van-row>
        </van-row>
        <van-divider></van-divider>
        <van-row :gutter="1" type="flex" justify="space-between">
          <van-col :span="6" style="text-align: center">
            <van-button size="small" type="danger" @click="orderReciveClick" :disabled="reciveBtnDisable">接受</van-button>
          </van-col>
          <van-col :span="6">
            <van-button type="primary" size="small" @click="orderShopRejectClick"><div style="width:3rem;margin: 2px">今日不再接此店铺</div></van-button>
          </van-col>
          <van-col :span="6">
            <van-button type="primary" size="small" @click="orderRejectClick">拒绝</van-button>
          </van-col>
        </van-row>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import addReviceOrder from '../../components/AddButton'
import {getOrderPlateforms} from "../../api/system/sys_plateform";
import {MessageBox} from "mint-ui";
import {getOrderWithCustomer, setRejectOrderShop} from "../../api/system/mobile_taskorder";
import {serviceAttach} from "../../lib/dictToChiness";
import {isEmptyObject, isStrEmpty, replaceString} from "../../lib/utils";
export default {
  name: "OrderCondition",
  components:{
    addReviceOrder
  },
  data() {
    return {
      orderInfos: "接单信息",
      orderRequirement:{
        taskId:0,
        oneLeave:0,
        twoLeave:0,
        plateformInfo:{
        }
      },
      btn:"接单",
      reciveBtnDisable: false,
      disabled:false,
      shopNameShowPosition:"",
      b2cReciveOrderLimit:{},
      bindShop: 0,
      cardData: [{
        thumbUrl: "https://img01.yzcdn.cn/vant/ipad.jpeg",
        shopName: "2119273",
        reviewStatus: "(审核通过)",
        subtitles: "今日已接单(0/3),30天内可接单(0/40)",
        selected:1
      }
      ],
      orderInfo:{
      },
      timeCount:0,
      isShow:false,
      icons: [
        {
          id: 1,
          icon: require("../../assets/img/0.png")
        },
        {
          id: 2,
          icon: require("../../assets/img/1.png")
        },
        {
          id: 3,
          icon: require("../../assets/img/2.png")
        },
        {
          id: 4,
          icon: require("../../assets/img/3.png")
        },
        {
          id: 5,
          icon: require("../../assets/img/5.png")
        }
      ]
    }
  },
  computed:{
    getIcon() {
      return function (id) {
        for (let i of this.icons) {
          if (i.id == id) {
            return i.icon
          }
        }
        return null;
      }
    },
    getDayOrders(){
      return function (data){
        if (data != null){
          this.shopNameShowPosition = data.b2cReciveOrderLimit!=null&&data.b2cReciveOrderLimit.shopNameShowPosition!=null?data.b2cReciveOrderLimit.shopNameShowPosition:null;
          this.b2cReciveOrderLimit = data.b2cReciveOrderLimit;
          if (data.b2cReciveOrderLimit!=null&& data.b2cReciveOrderLimit.isAccountRepurchase){
            return data.b2cReciveOrderLimit.orderNumbersToday;
          }else{
            switch (data.plateformSerNum) {
              case "1":
                return data.b2cReciveOrderLimit.taoOrdersLimit;
                break;
                case "2":
                  return data.b2cReciveOrderLimit.jdOrdersLimit;
                  break;
              case "3":
                return data.b2cReciveOrderLimit.pddOrdersLimit;
                break;
              case "4":
                return data.b2cReciveOrderLimit.dyOrdersLimit;
                break;
              case "5":
                return data.b2cReciveOrderLimit.albabaOrdersLimit;
                break;
            }
          }
        }else{
          return 0;
        }
      }
    },
    getShopNameLimit(){
      return function (shopName){
        console.log(this.shopNameShowPosition)
        if (this.shopNameShowPosition && shopName){
          let indexAry = this.shopNameShowPosition.split(',');
          return replaceString(shopName, indexAry, '*');
        }
        return null;
      }
    },
    getMonthDays(){
      return function (data){
        if (data != null&&data.b2cReciveOrderLimit!=null){
          return data.b2cReciveOrderLimit.plateformCommonDay;
        }else{
          return 0;
        }
      }
    },
    getMonthOrders(){
      return function (data){
        if (data != null&&data.b2cReciveOrderLimit!=null){
          return data.b2cReciveOrderLimit.plateformCommitLimit;
        }else{
          return 0;
        }
      }
    },
    getServiceAttach() {
      return function (taskRequirement) {
        if (taskRequirement !== undefined){
          console.log(taskRequirement)
          let tmpArray = new Array();
          for (let key in JSON.parse(taskRequirement)) {
            console.log(key, serviceAttach[key])
            if (key.includes("Checked")
                || key.includes("customeVerifyReview")){
              if (serviceAttach[key]){
                let keys = Object.keys(serviceAttach[key]);
                console.log(keys)
                if (keys.includes(key.replace("Checked", ""))
                    || keys.includes("customeVerifyReview")) {
                  for (let subKey in keys) {
                    //console.log(keys[subKey])
                    if (keys[subKey] != "name") {
                      //console.log(serviceAttach[key], serviceAttach[key][keys[subKey]])
                      let Indx = 0;
                      if (Object.keys(JSON.parse(taskRequirement)).includes(keys[subKey])) {
                        Indx = 1;
                      }
                      tmpArray.push(serviceAttach[key].name);
                    }
                  }
                } else {
                  tmpArray.push(serviceAttach[key].name);
                }
              }
            }
          }
          console.log(tmpArray)
          return this.filterKeys(tmpArray).toString();
        }
      }
    },
  },
  mounted() {
    this.$emit("titleChange", "接单筛选");
  },
  methods:{
    filterKeys(lists) {
        return lists.filter(item => !isStrEmpty(item)&&!item.includes("限制")&&!item.includes("商家自主审核"));
    },
    reciveOrderButtonDisableTime(){
      this.btn = this.b2cReciveOrderLimit.customerOrderLimit;
      this.disabled = true;
      let a = setInterval(()=>{
        if (this.btn >  0){
          --this.btn;
        }else{
          this.btn = "接单";
          this.disabled = false;
          clearInterval(a);
        }
      }, 1000);
    },
    orderRejectClick(){
      this.isShow = false;
      this.orderInfo.isReciveOrder = false;
      this.orderInfo.b2cShopsId = null;
      setRejectOrderShop(this.orderInfo).then(res=>{
        if (res.success){
          this.isShow = false;
          //this.btn = 30;
          this.reciveOrderButtonDisableTime();
        }
      }).catch(err => {
        MessageBox.alert(err.message,
            '提示').then(action=>{
          this.reciveOrderButtonDisableTime();
        });
      });
    },
    orderShopRejectClick(){
      this.orderInfo.isReciveOrder = false;
      setRejectOrderShop(this.orderInfo).then(res=>{
        if (res.success){
          console.log(res.data);
          this.isShow = false;
          //this.btn = 30;
          this.reciveOrderButtonDisableTime();
        }
      }).catch(err => {
        MessageBox.alert(err.message,
          '提示').then(action=>{
          this.reciveOrderButtonDisableTime();
        });
      });
    },
    orderReciveClick(){
      this.orderInfo.isReciveOrder = true;
      this.orderInfo.plateformInfo = this.orderRequirement.plateformInfo;
      this.orderInfo.customerOrderLimit = {
        orderToday:this.getDayOrders(this.cardData[0]),
        orderMonth:this.getMonthOrders(this.cardData[0]),
      }
      this.reciveBtnDisable = true;
      setRejectOrderShop(this.orderInfo).then(res=>{
        if (res.success){
          this.reciveBtnDisable = false;
          this.isShow = false;
          //this.$router.push({path:'/home/usertaskmgelist'});
          this.$router.push({path: '/home/usertaskdetail', query:res.data});
          this.reciveOrderButtonDisableTime();
        }
      }).catch(err => {
        this.reciveBtnDisable = false;
        MessageBox.alert(err.message,
            '提示').then(action=>{
          this.reciveOrderButtonDisableTime();
        });
      });
    },
    selectShop(evl){
      console.log(evl);
      this.orderRequirement.plateformInfo = evl;
    },
    orderClick(){
      if (this.cardData == null || this.cardData.length <= 0){
        MessageBox.confirm(
          "请添加买手账号信息",
          '提示',
          ).then(action => {
            this.$router.push({path:'/home/bindaccountinfos'})
        });
      }else{
        if (isEmptyObject(this.orderRequirement.plateformInfo)){
          this.orderRequirement.plateformInfo = this.cardData[this.bindShop!= null?this.bindShop:0];
        }
        let that = this;
        getOrderWithCustomer(this.orderRequirement).then(res=>{
          if (res.success){
            console.log(res.data)
            that.isShow = !that.isShow;
            that.orderInfo = res.data;
            that.timeCount = 45;
            let t = setInterval(()=>{
              if (that.timeCount >  0){
                --that.timeCount;
              }else{
                that.isShow = false;
                clearInterval(t);
              }
            }, 1000);
          }
        }).catch(err => {
          MessageBox.alert(err.message,'提示').then(action=>{
            //this.reciveOrderButtonDisableTime();
            //处理催评订单， 则直接跳转
            if (err.message.indexOf("催评中") != -1){
              this.$router.push({path: '/home/usertaskmgelist', query:{status:8}});
            }
          });
        });
      }
    },
    bindAccount(){
      this.$router.push({path:'/home/bindaccountinfos'})
    },
    setData(data) {
      this.cardData = data;
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      getOrderPlateforms().then(res => {
        if (res.success) {
          vm.setData(res.data);
        }
      }).catch(err => {
        MessageBox({
          title: '提示',
          message: err.message,
          showCancelButton: true
        })
      });
    })
  }
}
</script>

<style lang="scss" scoped>

</style>
